import React, { FC, useContext, useMemo, useState } from 'react';

import { RenderElementProps } from 'slate-react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../../../constants/aampeTheme';
import ICONS from '../../../../../../constants/icons';

//context
import { EditorContext } from '../../../../../../context/EditorContext';

//models
import { FormulaStatus } from '../../../../../../models/formula.model';

// components
import ZeroWidthSpace from '../../ZeroWidthSpace';
import AttributePlaceholderModal from './AttributePlaceholderModal/AttributePlaceholderModal';

type AttributePlaceholderElementComponentProps = RenderElementProps & {
    element: any;
    editUserAttributePlaceholder: (
        id: string,
        defaultValue: string,
        attributeName: string,
    ) => void;
};
const AttributePlaceholderElementComponent: FC<
    React.PropsWithChildren<AttributePlaceholderElementComponentProps>
> = ({ children, element, attributes, editUserAttributePlaceholder }) => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);
    const [userAttributePlaceholderModal, setUserAttributePlaceholderModal] =
        useState<boolean>(false);
    const sampleValue = useMemo(() => {
        if (element) {
            return `${element.attributeName} | ${element.defaultValue}`;
        }
        return '';
    }, [element]);

    const isEditable = useMemo(
        () => formula?.active_state === FormulaStatus.Draft,
        [formula],
    );

    return (
        <Container {...attributes}>
            <PlaceholderComponent
                onClick={() => {
                    if (isEditable) {
                        setUserAttributePlaceholderModal(true);
                    }
                }}
            >
                <StyledIcon />
                {sampleValue}
            </PlaceholderComponent>
            <ZeroWidthSpace />
            {children}
            <ZeroWidthSpace />
            {userAttributePlaceholderModal && (
                <AttributePlaceholderModal
                    editUserAttributePlaceholder={editUserAttributePlaceholder}
                    handleClose={() => setUserAttributePlaceholderModal(false)}
                    userAttributeData={element}
                />
            )}
        </Container>
    );
};
export default AttributePlaceholderElementComponent;
const Container = styled.span({
    userSelect: 'none',
    outline: 'none',
    display: 'inline-block',
    borderRadius: aampeTheme.borderRadius.default,
    backgroundColor: aampeTheme.colors.interactiveWG01,
    padding: aampeTheme.spacing4(0, 1),
    color: aampeTheme.colors.neutral09,
    lineHeight: aampeTheme.size.lineHeight.default,
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.light,
    minWidth: '30px',
    border: `1px solid ${aampeTheme.colors.solidA02}`,
    cursor: 'pointer',
});
const StyledIcon = styled(ICONS.attributePlaceholder)({
    margin: aampeTheme.spacing4(0, 1, 1, 0),
    verticalAlign: 'middle',
    width: '16px',
    height: '16px',
    color: 'inherit',
});

const PlaceholderComponent = styled.span({
    userSelect: 'none',
});
